import React, { Component } from "react";
import Loading from "../../hoc/Loading/Loading";
import * as actionCreators from "../../modules/actions/index";
import { connect } from "react-redux";
import {
  Row,
  Table,
  Button,
  Alert,
  ModalHeader,
  Modal,
  ModalBody,
  Input,
} from "reactstrap";
import axios from "../../axios";
import { withRouter } from "react-router-dom";
import "./Groups.css";
import * as url from "../../utils/url";
import { grpBannerImg } from "../../utils/constants";
import moment from "moment";
import GroupListItem from "./GroupListItem";
import MetricsFilterComponent from "./Metrics/MetricsFilterComponent";

class GroupList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      groups: [],
      groupType: 0,
      displayNoGroupTxt: "",
      redirect_msg: null,
      filters: { filtersDoc: {} },
    };
  }

  // shouldComponentUpdate(prevProps, prevState) {
  //   if( (this.props.history.location.pathname !== prevProps.history.location.pathname) || (prevState.groupType!=this.state.groupType)){
  //     return true
  //   }
  //   return true
  // }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    // console.log('prev --- ', prevProps)
    // console.log('props --- ', this.props)
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.getGroupList();
      this.setState({ filters: {} }, () => {});
    }
  }

  componentDidMount() {
    let redirect_msg =
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.redirect_msg
        ? this.props.location.state.redirect_msg
        : null;
    this.setState({
      redirect_msg,
    });
    this.getGroupList();
    let orgId = this.props.user.profile.organizationId._id;
    axios.get(url.findOrgById(orgId)).then(({ data }) => {
      const payload = data.data;
      this.props.orgChangeSuccess(payload);
    });
  }

  getGroupList = (filters) => {
    let { match, location } = this.props,
      that = this;
    let url_value =
      location.pathname && location.pathname.length > 0
        ? location.pathname
        : "";
    let groupType;
    let { displayNoGroupTxt } = this.state;

    if (url_value.indexOf("discover") > -1) {
      groupType = 0;
      displayNoGroupTxt =
        "No groups have been created. Click here to create a group";
    } else if (url_value.indexOf("feed") > -1) {
      groupType = 1;
      displayNoGroupTxt =
        'Currently, you are not part of any groups. Start a group by clicking here, or to join a group, click on the left hand side menu option labeled "Discover".';
    } else {
      groupType = -1;
      displayNoGroupTxt = "You have not archived any of your groups.";
    }

    // url_value.indexOf('discover')>-1? 0: 1

    axios
      .post(url.getGroups, { groupType, filters })
      .then(({ data }) => {
        let resp = data.data;
        console.log("resp Group LIST --- ", resp);
        that.setState({
          groups: resp,
          groupType,
          displayNoGroupTxt,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  goToGroupPage = (group) => {
    let { profile } = this.props.user;
    this.props.history.push(
      `/home/groups/${profile.organizationId._id}/view/${group._id}`
    );
  };

  navCreateGrp = () => {
    this.props.history.push(
      `/home/groups/${this.props.user.profile.organizationId._id}/create`
    );
  };

  onDismiss = () => {
    this.setState({ redirect_msg: null });
  };

  render() {
    const { groups, groupType, displayNoGroupTxt, redirect_msg } = this.state;
    return (
      <span>
        <div className="grp_list_page_container col-md-11 col-lg-11 col-sm-11">
          <div className="grp_list_page_container_title">
            {groupType == 1
              ? "My Groups"
              : groupType == 0
              ? "All Groups"
              : "Archived Groups"}
          </div>
          <div
            className="grp_list_page_container_createBtn"
            onClick={() => this.navCreateGrp()}
          >
            + Create Group
          </div>
        </div>

        {redirect_msg && redirect_msg != null ? (
          <Alert
            className="col-md-8 col-lg-8 col-sm-8"
            color="danger"
            isOpen={redirect_msg != null}
            toggle={this.onDismiss}
          >
            Sorry, it seems like that group was archived and is no longer
            accessible.
          </Alert>
        ) : null}

        <div className="col-md-11 col-lg-11 col-sm-11 d-flex my-2">
          <div>
            {groups.length > 0 ? (
              <MetricsFilterComponent
                filterParams={this.state.filters}
                updateFilterParams={(data) => {
                  this.setState({ filters: { ...data } }, () => {
                    this.getGroupList({ ...data });
                  });
                }}
              />
            ) : this.state.filters &&
              this.state.filters.filtersDoc &&
              Object.keys(this.state.filters.filtersDoc).length > 0 ? (
              <MetricsFilterComponent
                filterParams={this.state.filters}
                updateFilterParams={(data) => {
                  this.setState({ filters: { ...data } }, () => {
                    this.getGroupList({ ...data });
                  });
                }}
              />
            ) : (
              ""
            )}
          </div>
        </div>

        <div className="row mx-1 col-md-11 col-lg-11 col-sm-12 col-xs-12 grp_list_page_container_pinGrid">
          {groups.length > 0 ? (
            groups.map((doc, idx) => {
              return (
                <div className={`col-md-4 my-2`} key={doc._id + idx}>
                  <GroupListItem
                    goToGroupPage={this.goToGroupPage}
                    groupType={groupType}
                    item={doc}
                  />
                </div>
              );
            })
          ) : (
            <div className="col-md-5 grp_list_page_item_container">
              <div className="card linkedChartItemStyling group_list_items_container group_list_items_001">
                <img
                  src={grpBannerImg}
                  className="banner_filter"
                  onClick={() => this.navCreateGrp()}
                />

                <div className="card-body">
                  <span onClick={() => this.navCreateGrp()}>
                    <span className="grp_list_no_groups_txt">
                      {" "}
                      {displayNoGroupTxt}{" "}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>
      </span>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    objectives: state.enterpriseObjective.objectives,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onFetchEnterpriseObjectives: (data) =>
      dispatch(actionCreators.storeEnterpriseObjectives(data)),
    orgChangeSuccess: (data) => dispatch(actionCreators.orgChangeSuccess(data)),
    resetObjective: () => dispatch(actionCreators.resetEnterpriseObjectives()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Loading(GroupList, axios))
);
